import React from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import Table from "../../constants/Table";

const QuotationDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation(); 
  const rfq = state?.rfq; 
  const isReviewDisabled = !rfq?.supplier_count || rfq.supplier_count === 0;

console.log(rfq,"rfq")
  if (!rfq) {
    return (
<div className="container-fluid rfq-container mt-4">
        <h5>No quotation details available</h5>
        <button className="btn btn-outline-secondary mt-3" onClick={() => navigate(-1)}>
          Go Back
        </button>
      </div>
    );
  }
const itemTableData = rfq?.items?.length
  ? rfq.items.map((item) => ([
      // `ITEM-${item.product_id}`,
      item.item,
      item.description || "—",
      item.quantity,
      `$${Number(item.estimated_price || 0).toLocaleString()}`
    ]))
  : [];
const itemHeaders = [
  // "Item ID",
  "Name",
  "Description",
  "Quantity",
  "Estimated Price"
];
const isDeadlinePassed = () => {
  if (!rfq?.responsible_date) return false;

  const deadline = new Date(rfq.responsible_date);

  // Make it end of that day instead of start
  deadline.setHours(23, 59, 59, 999);

  const now = new Date();

  return now > deadline;
};
  return (
    <div className="container mt-4">
 <div className="d-flex justify-content-between align-items-center mb-4">
  <div className="d-flex align-items-center gap-2">
    <FaArrowLeft
      className="cursor-pointer"
      size={18}
      onClick={() => navigate(-1)}
    />
    <h4 className="mb-0 fw-semibold">Quotation Details</h4>
  </div>

  <div className="d-flex gap-2">
    <button
      className="btn btn-danger"
      onClick={() =>
        navigate(`/reviewQuatation/${rfq.id}`, { state: { rfq } })
      }
      disabled={!isDeadlinePassed() || isReviewDisabled}
title={
  !isDeadlinePassed()
    ? "You can review quotations only after the deadline ends"
    : isReviewDisabled
    ? "No supplier has submitted a quotation yet"
    : ""
}

    >
      Review Quotation
    </button>
    <button className="btn export-btn">Export as PDF</button>
  </div>
</div>


      {/* Info + Summary */}
      <div className="row  align-items-stretch">
        {/* Left Card */}
 <div className="col-md-8">
  <div className="info-card">
    <h6 className="section-heading">Quotation Information</h6>

    <div className="info-grid">
      <div>
        <label>RFQ Number</label>
        <p style={{ fontWeight: 400 }}>{rfq.display_id}</p>
      </div>

     <div>
  <label>Status</label>
  <span className="status-chip bg-primary" style={{ display: "block",width:"170px" }}>
    {rfq?.rfq_status_name}
  </span>
</div>


      <div>
        <label>Title</label>
        <p style={{ fontWeight: 400 }}>{rfq.rfq_title}</p>
      </div>

      <div>
        <label>Created By</label>
        <p style={{ fontWeight: 400 }}>{rfq.first_name}</p>
      </div>

      <div>
        <label>Due Date</label>
        <p style={{ fontWeight: 400 }}>{new Date(rfq.responsible_date).toLocaleDateString()}</p>
      </div>

 <div>
  <label>Department</label>
<p style={{ fontWeight: 400 }}>{rfq.items?.[0]?.product_name || "—"}</p>
</div>


 <div className="full-width">
  <label>Description</label>
  <p style={{ fontWeight: 450 }}>
    {rfq.items && rfq.items.length > 0
      ? rfq.items
          .map(item => item.description)
          .filter(desc => desc) // remove null/empty
          .join(" - ")
      : "—"}
  </p>
</div>

    </div>
  </div>
</div>


 <div className="col-md-4">
  <div className="summary-card">
    <h6 className="section-heading">Summary</h6>

    <div className="summary-row">
      <span>Total Items</span>
      <strong>{rfq.total_items || 0}</strong>
    </div>

    <div className="summary-row">
      <span>Suppliers Invited</span>
      <strong>{rfq.suppliers_sent || 0}</strong>
    </div>

    <div className="summary-row">
      <span>Responses Received</span>
      <strong>{rfq.supplier_count || 0}</strong>
    </div>

    <hr />

   <div className="summary-row">
  <span>Lowest Bid</span>
  <strong className="text-success">
    ${rfq?.lowerBid}
  </strong>
</div>

  </div>
</div>

        <div className="col-md-12 d-flex mt-3">
<div className="col-md-12 mt-4">
<div className="table-card">
  <h6 className="section-heading">Requested Items</h6>
  {/* <div className="table-responsive rfq-table-scroll"> */}
    <Table
      headers={itemHeaders}
      data={itemTableData}
      pagination={false}
    />
  {/* </div> */}
</div>


</div>

</div>

      </div>
    </div>
  );
};

export default QuotationDetails;
